// extracted by mini-css-extract-plugin
export default {"reasonsField":"InvalidationModal_reasonsField__PwliP"};